::ng-deep particle-task-selector{display:flex;width:100%}::ng-deep particle-task-selector .toolbar.second-level-toolbar{padding:0;height:60px;min-height:60px;max-height:60px}::ng-deep particle-task-selector .pos-relative{margin:20px 0 0!important}
/*# sourceMappingURL=task-selector.component-6SUWRRTL.css.map */
